export default __webpack_public_path__ + "static/media/plane2.451beb3e.svg";